import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {useIntl} from "react-intl";
import {useToast} from "../../lib/hooks/useToast";
import {PenaltyInvoiceService} from "../../lib/services/penalty-invoice-service";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";

interface Props {
    showDialog: boolean;
    closeCb: () => void;
    selectedPenaltyInvoiceId: number
    invoiceNumber: string;
}

const DeletePenaltyInvoiceFile : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const toastHelpers = useToast();
    const penaltyInvoicesService = new PenaltyInvoiceService(f, toastHelpers);

    const [note, setNote] = useState<string>();

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const handleDeletePenaltyInvoiceFile = () => {
        penaltyInvoicesService.deletePenaltyInvoiceFile({penaltyInvoiceId: props.selectedPenaltyInvoiceId || 0, note: note || ""})
            .then(resp => {
                if(resp) props.closeCb();
            })
    }

    return <>

        <Dialog header={f({id: 'deletePenaltyInvoiceFile'}, {invoiceNumber: props.invoiceNumber})}
                onHide={props.closeCb}
                breakpoints={{'960px': '75vw', '640px': '100vw'}}
                visible={props.showDialog}>

            <p>{f({id: "confirmDeletePenaltyInvoiceFile"}, {invoiceNumber: props.invoiceNumber})}</p>

            <div className={"grid p-fluid justify-content-center mt-4"}>
                <div className={"col-12"}>
                            <span className="p-float-label">
                                <InputText value={note} onChange={(e) => setNote(e.target.value)}/>
                                <label>{f({id: "note"})}</label>
                            </span>
                </div>

                <div className={"col-12 md:col-6"}>
                    <Button label={f({id: "delete"})}
                            onClick={handleDeletePenaltyInvoiceFile}/>
                </div>

                <div className={"col-12 md:col-6"}>
                    <Button label={f({id: "cancel"})} onClick={props.closeCb}/>
                </div>
            </div>
        </Dialog>

    </>
};

export default DeletePenaltyInvoiceFile;
